import { GETLicensePayload } from "../utils";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { TbAlertCircle, TbAlertTriangle, TbCalendar } from "react-icons/tb";
import { Box, Flex, Badge, Text, Icon } from "@chakra-ui/react";

interface KPISummaryProps {
  licenseData: Partial<GETLicensePayload>;
}
export function ActiveLicensesOverview({ licenseData }: KPISummaryProps) {
  const masterActive = licenseData.qtyEnabledMaster ?? 0;
  const voActive = licenseData.qtyEnabledVendedorOrOperacional ?? 0;
  const totalMasterContracted = licenseData.qtyLicenseMaster ?? 0;
  const totalVendedorContracted =
    licenseData.qtyLicenseVendedorOrOperacional ?? 0;

  // Calculate nextDueDate and paymentStatus using start and end dates
  const nextDueDate = licenseData.expirationDate
    ? licenseData.expirationDate.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1")
    : "";
  const paymentStatus = licenseData.expired ? "Pendente" : "em_dia";
  const isExceedingMaster = masterActive > totalMasterContracted;
  const isExceedingVO = voActive > totalVendedorContracted;

  return (
    <Box
      bg="white"
      border="1px"
      borderColor="gray.200"
      borderRadius="lg"
      px={6}
      py={4}
      gap={4}
      boxShadow="sm"
      mb="4"
    >
      <Text
        fontWeight="semibold"
        color={licenseData.expired ? "red.600" : "gray.900"}
        mb="10px"
      >
        {licenseData.expired ? "Licença expirada" : "Licença ativa no momento"}
      </Text>

      <Flex
        flexDirection={{ base: "column", sm: "row" }}
        alignItems="center"
        justifyContent="space-between"
        w="100%"
        gap={6}
        fontSize="sm"
      >
        {/* USERS COUNT */}
        <Flex flexDir="column">
          <Flex alignItems="center" fontSize={13} flexWrap="wrap" gap="6px">
            <Box color="gray.500">Qtd. Master:</Box>
            <Box fontWeight="medium" color={"gray.900"}>
              {totalMasterContracted}
            </Box>
            <Box as="span" color="gray.400">
              {`(${masterActive} em uso)`}
            </Box>
          </Flex>

          <Flex alignItems="center" fontSize={13} flexWrap="wrap" gap="6px">
            <Box color="gray.500">Qtd. Vendedor/Operacional:</Box>
            <Box fontWeight="medium" color={"gray.900"}>
              {totalVendedorContracted}
            </Box>
            <Box as="span" color="gray.400">
              {`(${voActive} em uso)`}
            </Box>
          </Flex>
        </Flex>

        {/* DIVIDER */}
        <Box
          display={{ base: "none", sm: "block" }}
          w="1px"
          h={4}
          borderLeft="1px solid var(--chakra-colors-gray-200)"
        />

        <Flex flexDir="column" fontSize={13}>
          <Flex align="center" color="gray.500" gap={2}>
            <Icon as={TbCalendar} w={3} h={3} color="gray.400" />{" "}
            <Text>Expiração:</Text>
            <Text
              fontWeight="medium"
              color={licenseData.expired ? "red.600" : "gray.900"}
            >
              {nextDueDate}
            </Text>
          </Flex>
        </Flex>

        <Flex align="center" gap={2}>
          {paymentStatus === "em_dia" ? (
            <Badge
              colorScheme="green"
              variant="subtle"
              display="inline-flex"
              alignItems="center"
              size="md"
              gap={1.5}
              borderRadius="10px"
              h="24px"
            >
              <CheckCircleIcon w={3.5} h={3.5} />
              Em dia
            </Badge>
          ) : (
            <Badge
              colorScheme="red"
              variant="subtle"
              display="inline-flex"
              alignItems="center"
              size="md"
              borderRadius="10px"
              h="24px"
              gap={1.5}
            >
              <TbAlertCircle style={{ width: "14px", height: "14px" }} />
              Expirado
            </Badge>
          )}
        </Flex>
      </Flex>
      <Flex>
        {(isExceedingMaster || isExceedingVO) && (
          <Flex
            color="red.600"
            mt="-4px"
            p="2px 4px"
            borderRadius="10px"
            bg="red.50"
            border="1px"
            borderColor="red.100"
            gap={1}
            // alignItems="flex-start"
            fontSize="10px"
            fontWeight="medium"
            marginTop="15px"
            flexDirection="column"
            width="100%"
          >
            {isExceedingMaster && (
              <Box display="flex" alignItems="center" gap={1}>
                <Icon as={TbAlertTriangle} w={3} h={3} color="red.600" />{" "}
                {`${masterActive - totalMasterContracted} usuário${masterActive - totalMasterContracted > 1 ? "s" : ""} Master ativo${masterActive - totalMasterContracted > 1 ? "s" : ""} acima da quantidade licenciada`}{" "}
              </Box>
            )}
            {isExceedingVO && (
              <Box display="flex" alignItems="center" gap={1}>
                <Icon as={TbAlertTriangle} w={3} h={3} color="red.600" />{" "}
                {`${voActive - totalVendedorContracted} usuário${voActive - totalVendedorContracted > 1 ? "s" : ""} Vendedor/Operacional ativo${voActive - totalVendedorContracted > 1 ? "s" : ""} acima da quantidade licenciada`}
              </Box>
            )}
          </Flex>
        )}
      </Flex>
    </Box>
  );
}
